import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgTimeOutlined(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M11 6.00002C11 5.44773 11.4477 5.00002 12 5.00002C12.5523 5.00002 13 5.44773 13 6.00002V11.999C13 12.3039 12.8609 12.5922 12.6222 12.7819L8.74603 15.8624C8.31366 16.2061 7.6846 16.1341 7.34098 15.7018C6.99736 15.2694 7.0693 14.6403 7.50167 14.2967L11 11.5164V6.00002Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9991 1.00092C5.92399 1.00092 1 5.92692 1 12C1 18.075 5.9241 22.9991 11.9991 22.9991C18.0739 22.9991 23 18.0753 23 12C23 5.92669 18.074 1.00092 11.9991 1.00092ZM3 12C3 7.03126 7.02879 3.00092 11.9991 3.00092C16.9697 3.00092 21 7.03149 21 12C21 16.9702 16.9698 20.9991 11.9991 20.9991C7.02867 20.9991 3 16.9705 3 12Z", fill: "currentColor" })));
}
export default SvgTimeOutlined;
